import { z } from 'zod';

const lineSchema = z.object({
  invStockId: z.string().min(1, '請選擇庫存'),
  stockNo: z.string().optional().nullable(),
  mtrNo: z.string().optional().nullable(),
  mtrName: z.string().optional().nullable(),
  warehouseLabel: z.string().optional().nullable(),
  availableQty: z.union([z.string(), z.number()]).optional().nullable(),
  baseQty: z.union([z.string(), z.number(), z.null()]),
  remark: z.string().optional().nullable(),
}).superRefine((line, ctx) => {
  const qty = line.baseQty;
  const n = Number(qty);
  if (qty === '' || qty == null || !Number.isFinite(n) || n === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: '調整量須為非 0 整數',
      path: ['baseQty'],
    });
    return;
  }

  if (!Number.isInteger(n)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: '調整量須為整數',
      path: ['baseQty'],
    });
    return;
  }

  const current = Number(line.availableQty);
  const currentQty = Number.isFinite(current) ? current : 0;
  if (currentQty + n < 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: '調整後數量不可為負',
      path: ['baseQty'],
    });
  }
});

export const stockAdjustmentFormSchema = z.object({
  adjustmentDate: z.string().min(1, '請填寫單據日'),
  sourceType: z.enum(['MANUAL']).default('MANUAL'),
  sourceId: z.string().optional().nullable(),
  issueReason: z.string().min(1, '請填寫開單原因'),
  remark: z.string().optional().nullable(),
  lines: z.array(lineSchema).min(1, '至少一筆明細').superRefine((lines, ctx) => {
    const seen = new Set();
    lines.forEach((line, index) => {
      const id = line.invStockId?.trim();
      if (!id) {
        return;
      }
      if (seen.has(id)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: '同一庫存不可重複',
          path: [index, 'invStockId'],
        });
        return;
      }
      seen.add(id);
    });
  }),
});

export const STOCK_ADJUSTMENT_FIELD_LABELS = {
  adjustmentDate: '單據日',
  sourceType: '來源類型',
  sourceId: '來源單號',
  issueReason: '開單原因',
  remark: '備註',
  lines: '明細',
  'lines.invStockId': '庫存',
  'lines.baseQty': '調整量',
  'lines.remark': '行備註',
};

export const ADJUSTMENT_LINES_MERGE_TIP =
  '手動合併請用兩筆獨立調整：一筆負向、一筆正向；系統不驗證成對。';
